export default function PageTabBody({ tabs, activeTab }) {
  const activeTabData = tabs.find((tab) => tab.id === activeTab);
  if (!activeTabData) return null;

  return <div className="mt-2">{activeTabData.content}</div>;
}
